import { render, staticRenderFns } from "./GrantFarmAccess.vue?vue&type=template&id=3648ea14&scoped=true"
import script from "./GrantFarmAccess.vue?vue&type=script&lang=js"
export * from "./GrantFarmAccess.vue?vue&type=script&lang=js"
import style0 from "./GrantFarmAccess.vue?vue&type=style&index=0&id=3648ea14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648ea14",
  null
  
)

export default component.exports